import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { trTR, enUS as enUSPickers } from '@mui/x-date-pickers/locales';
import { enUS, tr } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';

interface DatePickerProviderProps {
  children: React.ReactNode;
}

const pickerLocaleText = (isEnglish: boolean) => {
  const base = isEnglish
    ? enUSPickers.components.MuiLocalizationProvider.defaultProps.localeText
    : trTR.components.MuiLocalizationProvider.defaultProps.localeText;

  // trTR paketinde yalnizca "iptal" kucuk harfle geliyor; diger butonlarla tutarli olsun.
  return isEnglish ? base : { ...base, cancelButtonLabel: 'İptal' };
};

/**
 * Tum uygulamadaki tarih secicilerin ortak saglayicisi.
 *
 * adapterLocale takvimdeki ay/gun adlarini, localeText ise "Bugun / Tamam / Temizle"
 * gibi buton ve erisilebilirlik metinlerini belirler. Ikisi de arayuz diline gore secilir.
 */
export const DatePickerProvider: React.FC<DatePickerProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const isEnglish = Boolean(i18n.language?.toLowerCase().startsWith('en'));
  const adapterLocale = isEnglish ? enUS : tr;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={adapterLocale}
      localeText={pickerLocaleText(isEnglish)}
    >
      {children}
    </LocalizationProvider>
  );
};
